import React, { useEffect, useState } from "react";
import {
  Form, Input, Button, Select, Row, Col, Image, message, Upload, Spin,
} from "antd";
import { CopyOutlined, UploadOutlined, CameraOutlined, EditOutlined } from "@ant-design/icons";
import { FaFacebook, FaInstagram, FaTwitter, FaWhatsapp } from "react-icons/fa6";
import {
  FaUser, FaUsers, FaMapMarkerAlt, FaGraduationCap, FaImages, FaKey, FaTrash,
  FaHeart, FaBriefcase, FaPray, FaBirthdayCake, FaRulerVertical, FaMoneyBillWave,
  FaRing, FaVenusMars, FaPhone, FaEnvelope, FaGlobeAsia, FaCity, FaUserTie,
  FaLinkedin, FaYoutube, FaLink, FaWallet,
} from "react-icons/fa";
import {
  UserGet, UserUpdate, UserDataGet, UserDataUpdate,
  UserImagesGet, UserImagesPost, UserImagesRemove,
} from "../../Api/CoreApi";
import {BASE_API} from "../../Api/Api"
import { useNavigate } from "react-router-dom";
import defaultCover from "../../Assets/Cover_Images/Profile_Img.jpg";
import Profile_Header from "./Profile_Header";
import Footer from "../../Home_Page_WLog/Footer/Footer";

const { Option } = Select;

function User_Profile_User() {
  const Navigate = useNavigate();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const baseurl = "BASE_API";
  const id = localStorage.getItem("user_id");
  const int_id = String(id);
  const [activeTab, setActiveTab] = useState("overview");
  const [editMode, setEditMode] = useState(false);
  const [User, setUser] = useState([]);
  const [obj, setObj] = useState([]);
  const [image, setImage] = useState([]);
  const user_role = localStorage.getItem("role");

  const permission = () => { if (user_role === null || user_role !== "user") Navigate("/"); };

  const get_user = async () => {
    const response = await UserGet();
    const filter = response.filter((i) => i.id === int_id);
    setUser(filter); setObj(filter[0]);
    const response1 = await UserDataGet();
    const filter_data = response1.filter((i) => i.User_id === int_id);
    const add = {
      ...filter_data[0],
      username: filter.map((i) => i.username).join(", "),
      password: filter.map((i) => i.password).join(", "),
      balance: filter.map((i) => i.balance).join(", "),
    };
    form.setFieldsValue(add);
    setUser([add]);
  };

  const get_user_image = async () => {
    const response = await UserImagesGet();
    setImage(response.filter((i) => i.user_id === int_id));
  };

  useEffect(() => { permission(); get_user(); get_user_image(); }, []);

  const submit = async (value) => { message.success("Success"); get_user(); };
  const submit1 = async (value) => {
    const d = new Date(value.dob), t = new Date();
    value.age = t.getFullYear() - d.getFullYear() - (t < new Date(t.getFullYear(), d.getMonth(), d.getDate()));
    await UserUpdate(id, value); await UserDataUpdate(id, value);
    message.success("Success"); setEditMode(false); get_user();
  };
  const Login_update = async (value) => { await UserUpdate(id, value); message.success("Success"); get_user(); };
  const img_update = async (value) => {
    setIsLoading(true);
    const fd = new FormData(); Object.entries(value).forEach(([k, v]) => fd.append(k, v));
    await UserUpdate(id, fd); await UserDataUpdate(id, fd);
    setIsLoading(false); message.success("Success"); get_user();
  };
  const user_img_post = async (value) => {
    setIsLoading(true);
    const fd = new FormData(); fd.append("user_id", id);
    Object.entries(value).forEach(([k, v]) => fd.append(k, v));
    const r = await UserImagesPost(fd); setImage(r.filter((i) => i.user_id === int_id));
    setIsLoading(false); message.success("Success"); get_user();
  };
  const user_img_delete = async (value) => {
    const r = await UserImagesRemove(value); setImage(r.filter((i) => i.user_id === int_id));
    message.success("Success"); get_user();
  };
  const handlecoverImage = async (info) => {
    setIsLoading(true);
    const file = info.file.originFileObj || info.file; if (!file) return;
    const fd = new FormData(); fd.append("cover_img", file);
    try { const r = await UserDataUpdate(int_id, fd); setUser(r.filter((i) => i.User_id === int_id)); message.success("Upload success"); }
    catch (e) { } finally { setIsLoading(false); }
  };
  const copyField = (field) => {
    const v = form.getFieldValue(field);
    if (v) { navigator.clipboard.writeText(v); message.success("Copied!"); }
    else message.warning("Nothing to copy");
  };

  const tabs = [
    { key: "overview", label: "Overview", icon: <FaUser /> },
    { key: "gallery", label: "Gallery", icon: <FaImages /> },
    { key: "edit", label: "Edit Profile", icon: <EditOutlined /> },
    { key: "login", label: "Account", icon: <FaKey /> },
    { key: "family", label: "Family", icon: <FaUsers /> },
    { key: "address", label: "Location", icon: <FaMapMarkerAlt /> },
    { key: "education", label: "Education", icon: <FaGraduationCap /> },
  ];

  const InfoCard = ({ icon, label, value }) => (
    <div className="sp-info-card">
      <div className="sp-info-icon">{icon}</div>
      <div><div className="sp-info-label">{label}</div><div className="sp-info-value">{value || "—"}</div></div>
    </div>
  );

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap');
        *{font-family:'Poppins',sans-serif!important;box-sizing:border-box;margin:0}

        @keyframes spPulse{0%,100%{box-shadow:0 0 0 0 rgba(255,0,85,.3)}50%{box-shadow:0 0 0 12px rgba(255,0,85,0)}}
        @keyframes spSlide{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}

        .sp-page{background:#f8f4f6;min-height:100vh}

        .sp-wrap{max-width:1100px;margin:0 auto;padding:78px 16px 40px}

        /* Cover */
        .sp-cover-wrap{position:relative;height:300px;border-radius:24px 24px 0 0;overflow:hidden;background:#eee}
        .sp-cover-img{width:100%!important;height:100%!important;object-fit:cover!important}
        .sp-cover-gradient{position:absolute;inset:0;background:linear-gradient(to bottom,transparent 40%,rgba(0,0,0,.5))}
        .sp-cover-btn{position:absolute;bottom:16px;right:16px;z-index:5}
        .sp-cover-btn .ant-btn{border-radius:14px!important;background:rgba(255,255,255,.9)!important;border:1.5px solid #ffe4ec!important;color:#ff0055!important;font-weight:600!important;font-size:12px!important;height:38px!important;box-shadow:0 4px 14px rgba(0,0,0,.08)!important}

        /* Main Card */
        .sp-main{background:#fff;border-radius:0 0 24px 24px;box-shadow:0 8px 40px rgba(255,0,85,.06);border:1px solid #ffe8ef;position:relative}

        /* Profile header strip */
        .sp-profile-strip{display:flex;align-items:flex-end;gap:20px;padding:0 28px 20px;margin-top:-55px;position:relative;z-index:10;flex-wrap:wrap}
        .sp-avatar-box{width:120px;height:120px;border-radius:50%;padding:4px;background:linear-gradient(135deg,#ff0055,#ff4d88,#ff80aa);box-shadow:0 10px 30px rgba(255,0,85,.2);flex-shrink:0;position:relative}
        .sp-avatar-img{width:100%;height:100%;border-radius:50%;object-fit:cover;border:3px solid #fff}
        .sp-avatar-cam{position:absolute;bottom:2px;right:2px;z-index:11}
        .sp-avatar-cam .ant-btn{width:32px!important;height:32px!important;border-radius:50%!important;background:linear-gradient(135deg,#ff0055,#ff4d88)!important;border:2px solid #fff!important;color:#fff!important;font-size:14px!important;padding:0!important;box-shadow:0 4px 12px rgba(255,0,85,.3)!important}

        .sp-profile-info{flex:1;min-width:200px;padding-bottom:4px}
        .sp-name{font-size:26px;font-weight:800;color:#1a0a10;margin:0 0 2px;line-height:1.2}
        .sp-id-badge{display:inline-flex;align-items:center;gap:5px;padding:4px 12px;border-radius:999px;background:linear-gradient(135deg,#fff0f3,#ffe4ec);color:#ff0055;font-size:11px;font-weight:700;border:1px solid #ffd3df;margin-top:4px}
        .sp-meta-row{display:flex;flex-wrap:wrap;gap:14px;margin-top:8px}
        .sp-meta{display:flex;align-items:center;gap:5px;font-size:12.5px;color:#777;font-weight:500}
        .sp-meta svg{color:#ff4d88;font-size:13px}

        .sp-profile-actions{display:flex;gap:8px;align-items:flex-end;padding-bottom:8px}

        /* Social strip */
        .sp-social-strip{display:flex;align-items:center;gap:8px;padding:14px 28px;border-top:1.5px solid #fff0f3;border-bottom:1.5px solid #fff0f3;flex-wrap:wrap;background:#fffafc}
        .sp-soc{width:38px;height:38px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:15px;color:#fff;text-decoration:none;transition:all .3s ease;box-shadow:0 4px 12px rgba(0,0,0,.08)}
        .sp-soc:hover{transform:translateY(-2px) scale(1.06)}
        .sp-soc.wa{background:linear-gradient(135deg,#25d366,#128c7e)}
        .sp-soc.fb{background:linear-gradient(135deg,#1877f2,#0d47a1)}
        .sp-soc.ig{background:linear-gradient(135deg,#e1306c,#c13584)}
        .sp-soc.tw{background:linear-gradient(135deg,#1da1f2,#0d8ecf)}
        .sp-balance{margin-left:auto;display:flex;align-items:center;gap:6px;padding:8px 16px;border-radius:14px;background:linear-gradient(135deg,#fff0f3,#ffe4ec);color:#ff0055;font-size:13px;font-weight:700;border:1px solid #ffd3df}

        /* Two column layout */
        .sp-layout{display:grid;grid-template-columns:220px 1fr;min-height:400px}

        /* Side nav */
        .sp-sidebar{padding:20px 0;border-right:1.5px solid #fff0f3;background:#fffafc}
        .sp-nav-item{display:flex;align-items:center;gap:8px;padding:11px 24px;font-size:13px;font-weight:600;color:#888;cursor:pointer;border:none;background:none;width:100%;text-align:left;transition:all .25s ease;border-left:3px solid transparent}
        .sp-nav-item:hover{color:#ff0055;background:#fff0f3}
        .sp-nav-item.active{color:#ff0055;background:linear-gradient(90deg,#fff0f3,#fff);border-left-color:#ff0055;font-weight:700}
        .sp-nav-item svg{font-size:15px;width:18px}

        /* Content */
        .sp-content{padding:24px 28px;animation:spSlide .4s ease}

        .sp-section-title{font-size:20px;font-weight:800;color:#1a0a10;margin:0 0 18px;display:flex;align-items:center;gap:8px}
        .sp-section-title svg{color:#ff0055}

        /* Info cards grid */
        .sp-info-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:12px}
        .sp-info-card{display:flex;align-items:flex-start;gap:12px;padding:14px;border-radius:16px;background:linear-gradient(135deg,#fffafc,#fff0f3);border:1.5px solid #ffe4ec;transition:all .3s ease}
        .sp-info-card:hover{border-color:#ffb3c8;box-shadow:0 6px 18px rgba(255,0,85,.05);transform:translateY(-1px)}
        .sp-info-icon{width:36px;height:36px;border-radius:11px;background:linear-gradient(135deg,#ffe6ee,#ffd4e1);display:flex;align-items:center;justify-content:center;color:#ff0055;font-size:14px;flex-shrink:0}
        .sp-info-label{font-size:10.5px;font-weight:700;color:#c2185b;text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px}
        .sp-info-value{font-size:14px;font-weight:600;color:#1a0a10}

        /* Form */
        .sp-content .ant-form-item-label>label{font-weight:700!important;color:#c2185b!important;font-size:12.5px!important}
        .sp-content .ant-input,.sp-content .ant-input-affix-wrapper,.sp-content .ant-select-selector,.sp-content .ant-input-password{border-radius:14px!important;border:1.8px solid #f6bfd0!important;min-height:46px!important;font-size:13px!important;box-shadow:0 2px 8px rgba(255,0,85,.03)!important;transition:all .3s ease!important}
        .sp-content .ant-input{padding:0 14px!important}
        .sp-content .ant-input-affix-wrapper{padding:0 14px!important;display:flex!important;align-items:center!important}
        .sp-content .ant-input-affix-wrapper input.ant-input{border:none!important;box-shadow:none!important;background:transparent!important;height:auto!important;min-height:auto!important;padding:0!important}
        .sp-content .ant-select-selector{display:flex!important;align-items:center!important;padding:0 14px!important}
        .sp-content .ant-input:hover,.sp-content .ant-input-affix-wrapper:hover,.sp-content .ant-select-selector:hover{border-color:#ff7ca8!important}
        .sp-content .ant-input:focus,.sp-content .ant-input-focused,.sp-content .ant-input-affix-wrapper-focused,.sp-content .ant-select-focused .ant-select-selector{border-color:#ff0055!important;box-shadow:0 0 0 3px rgba(255,0,85,.10)!important}
        .sp-content .ant-form-item{margin-bottom:16px}

        .sp-save-btn{height:44px!important;border-radius:999px!important;border:none!important;background:linear-gradient(135deg,#ff0055,#ff4d88)!important;color:#fff!important;font-weight:700!important;font-size:13px!important;padding:0 28px!important;box-shadow:0 6px 18px rgba(255,0,85,.2)!important;transition:all .3s ease!important}
        .sp-save-btn:hover{transform:translateY(-2px)!important;box-shadow:0 10px 24px rgba(255,0,85,.28)!important}

        /* Gallery */
        .sp-gallery{display:grid;grid-template-columns:repeat(auto-fill,minmax(130px,1fr));gap:10px;margin-top:12px}
        .sp-gal-item{position:relative;border-radius:14px;overflow:hidden;border:2px solid #ffe4ec;transition:all .3s ease}
        .sp-gal-item:hover{transform:translateY(-2px);box-shadow:0 8px 20px rgba(255,0,85,.08);border-color:#ff80aa}
        .sp-gal-item img{width:100%!important;height:auto!important;display:block!important}
        .sp-gal-del{position:absolute;top:6px;right:6px;width:28px;height:28px;border-radius:50%;background:rgba(255,0,85,.85);color:#fff;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:11px;box-shadow:0 4px 10px rgba(255,0,85,.3);transition:all .3s ease}
        .sp-gal-del:hover{background:#ff0055;transform:scale(1.1)}
        .sp-upload-btn{border-radius:14px!important;border:2px dashed #ffc2d1!important;background:linear-gradient(135deg,#fff0f3,#ffe4ec)!important;color:#ff0055!important;font-weight:600!important;height:40px!important}

        /* Responsive */
        @media(max-width:768px){
          .sp-layout{grid-template-columns:1fr}
          .sp-sidebar{display:flex;overflow-x:auto;padding:0;border-right:none;border-bottom:1.5px solid #fff0f3;gap:0}
          .sp-nav-item{white-space:nowrap;padding:10px 16px;border-left:none;border-bottom:3px solid transparent;font-size:12px}
          .sp-nav-item.active{border-left-color:transparent;border-bottom-color:#ff0055}
          .sp-nav-item svg{display:none}
          .sp-cover-wrap{height:200px;border-radius:16px 16px 0 0}
          .sp-profile-strip{padding:0 16px 16px;margin-top:-45px;gap:14px}
          .sp-avatar-box{width:100px;height:100px}
          .sp-name{font-size:22px}
          .sp-content{padding:18px 16px}
          .sp-info-grid{grid-template-columns:repeat(auto-fill,minmax(160px,1fr))}
          .sp-social-strip{padding:10px 16px}
          .sp-wrap{padding:70px 10px 30px}
        }
        @media(max-width:480px){
          .sp-cover-wrap{height:160px}
          .sp-avatar-box{width:85px;height:85px}
          .sp-name{font-size:20px}
          .sp-info-grid{grid-template-columns:1fr}
          .sp-gallery{grid-template-columns:repeat(auto-fill,minmax(100px,1fr))}
          .sp-profile-strip{margin-top:-40px}
          .sp-main{border-radius:0 0 18px 18px}
        }

        /* ===== SELECT FIX ===== */

/* Select box proper display */
.sp-content .ant-select {
  width: 100% !important;
}

.sp-content .ant-select-selector {
  display: flex !important;
  align-items: center !important;
  padding: 0 14px !important;
  min-height: 46px !important;
  height: auto !important;
  border-radius: 14px !important;
  border: 1.8px solid #f6bfd0 !important;
  background: #fff !important;
  box-shadow: 0 2px 8px rgba(255,0,85,.03) !important;
}

.sp-content .ant-select-selection-item {
  line-height: 44px !important;
  font-size: 13px !important;
  color: #333 !important;
}

.sp-content .ant-select-selection-placeholder {
  line-height: 44px !important;
  font-size: 13px !important;
  color: #bbb !important;
}

/* Arrow icon */
.sp-content .ant-select-arrow {
  color: #ff0055 !important;
  right: 14px !important;
}

/* Hover */
.sp-content .ant-select:hover .ant-select-selector {
  border-color: #ff7ca8 !important;
}

/* Focus */
.sp-content .ant-select-focused .ant-select-selector {
  border-color: #ff0055 !important;
  box-shadow: 0 0 0 3px rgba(255,0,85,.10) !important;
}

/* ===== DROPDOWN OPTIONS FIX ===== */

/* Make sure dropdown is above everything */
.ant-select-dropdown {
  z-index: 9999 !important;
  border-radius: 14px !important;
  box-shadow: 0 12px 36px rgba(255,0,85,.12) !important;
  border: 1px solid #ffe4ec !important;
  padding: 6px !important;
}

/* Each option */
.ant-select-item {
  border-radius: 10px !important;
  padding: 8px 14px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #555 !important;
  transition: all 0.2s ease !important;
}

/* Option hover */
.ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background: #fff0f3 !important;
  color: #ff0055 !important;
}

/* Option selected */
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background: linear-gradient(135deg, #ffe4ec, #fff0f3) !important;
  color: #ff0055 !important;
  font-weight: 700 !important;
}

/* ===== ALSO FIX: Select inside Input with addonAfter ===== */
.sp-content .ant-input-group-addon {
  background: #fff0f3 !important;
  border: 1.8px solid #f6bfd0 !important;
  border-left: none !important;
  border-radius: 0 14px 14px 0 !important;
}

.sp-content .ant-input-group-addon .ant-btn {
  color: #ff0055 !important;
}

.sp-content .ant-input-group > .ant-input:first-child {
  border-radius: 14px 0 0 14px !important;
}
      `}</style>

      <Profile_Header />

      <div className="sp-page">
        <div className="sp-wrap">
          {User.map((i) => (
            <Spin spinning={isLoading} tip="Saving..." size="large" key={i.User_id || "u"}>
              {/* Cover */}
              <div className="sp-cover-wrap">
                <Image className="sp-cover-img" src={i?.cover_img ? `${baseurl}${i.cover_img}` : defaultCover} preview={true} />
                <div className="sp-cover-gradient"></div>
                <div className="sp-cover-btn">
                  <Upload showUploadList={false} beforeUpload={() => false} onChange={handlecoverImage}>
                    <Button icon={<CameraOutlined />} loading={isLoading}>Cover</Button>
                  </Upload>
                </div>
              </div>

              <div className="sp-main">
                {/* Profile Strip */}
                <div className="sp-profile-strip">
                  <div className="sp-avatar-box">
                    <img className="sp-avatar-img" src={`${i.pic}`} alt="profile" />
                    <div className="sp-avatar-cam">
                      <Upload beforeUpload={(f) => { img_update({ pic: f }); return false; }} showUploadList={false}>
                        <Button icon={<CameraOutlined />} />
                      </Upload>
                    </div>
                  </div>
                  <div className="sp-profile-info">
                    <h1 className="sp-name">{i.firstname}</h1>
                    {i.refer && <div className="sp-id-badge">💖 ID: {i.refer}</div>}
                    <div className="sp-meta-row">
                      {i.age && <span className="sp-meta"><FaBirthdayCake /> {i.age} yrs</span>}
                      {i.gender && <span className="sp-meta"><FaVenusMars /> {i.gender}</span>}
                      {i.city && <span className="sp-meta"><FaMapMarkerAlt /> {i.city}, {i.state}</span>}
                      {i.caste && <span className="sp-meta"><FaPray /> {i.caste}</span>}
                    </div>
                  </div>
                </div>

                {/* Social strip */}
                <div className="sp-social-strip">
                  <a href={`https://wa.me/?text=${encodeURIComponent(`User ID: ${i.refer}\n`)}${encodeURIComponent(`https://communityrishtey.com/User_Data_wl/${i.User_id}`)}`} target="_blank" rel="noopener noreferrer" className="sp-soc wa"><FaWhatsapp /></a>
                  <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`https://communityrishtey.com/User_Data_wl/${i.User_id}`)}`} target="_blank" rel="noopener noreferrer" className="sp-soc fb"><FaFacebook /></a>
                  <a href={`${i.instagram}`} target="_blank" rel="noopener noreferrer" className="sp-soc ig"><FaInstagram /></a>
                  <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(`https://communityrishtey.com/User_Data_wl/${i.User_id}`)}&text=Check!`} target="_blank" rel="noopener noreferrer" className="sp-soc tw"><FaTwitter /></a>
                  {i.balance && <div className="sp-balance"><FaWallet /> ₹{i.balance}</div>}
                </div>

                {/* Two column layout */}
                <div className="sp-layout">
                  {/* Sidebar */}
                  <div className="sp-sidebar">
                    {tabs.map((t) => (
                      <button key={t.key} className={`sp-nav-item ${activeTab === t.key ? "active" : ""}`} onClick={() => setActiveTab(t.key)}>
                        {t.icon} {t.label}
                      </button>
                    ))}
                  </div>

                  {/* Content */}
                  <div className="sp-content">
                    {/* Overview */}
                    {activeTab === "overview" && (
                      <>
                        <h2 className="sp-section-title"><FaUser /> Profile Overview</h2>
                        <div className="sp-info-grid">
                          <InfoCard icon={<FaUser />} label="Name" value={i.firstname} />
                          <InfoCard icon={<FaPray />} label="Caste" value={i.caste} />
                          <InfoCard icon={<FaPray />} label="Religion" value={i.religion} />
                          <InfoCard icon={<FaBirthdayCake />} label="DOB" value={i.dob ? new Date(i.dob).toLocaleDateString("en-GB") : ""} />
                          <InfoCard icon={<FaVenusMars />} label="Gender" value={i.gender} />
                          <InfoCard icon={<FaBirthdayCake />} label="Age" value={i.age} />
                          <InfoCard icon={<FaRing />} label="Marital Status" value={i.marrige_status} />
                          <InfoCard icon={<FaBriefcase />} label="Job" value={i.job_title} />
                          <InfoCard icon={<FaUserTie />} label="Job Type" value={i.job_type} />
                          <InfoCard icon={<FaMoneyBillWave />} label="Salary" value={i.salary} />
                          <InfoCard icon={<FaRulerVertical />} label="Height" value={i.height} />
                          <InfoCard icon={<FaPhone />} label="Contact" value={i.contact} />
                          <InfoCard icon={<FaEnvelope />} label="Email" value={i.email} />
                          <InfoCard icon={<FaCity />} label="City" value={i.city} />
                          <InfoCard icon={<FaGlobeAsia />} label="State" value={i.state} />
                          <InfoCard icon={<FaGraduationCap />} label="Course" value={i.course} />
                          <InfoCard icon={<FaGraduationCap />} label="University" value={i.university} />
                        </div>
                      </>
                    )}

                    {/* Gallery */}
                    {activeTab === "gallery" && (
                      <>
                        <h2 className="sp-section-title"><FaImages /> Photo Gallery</h2>
                        <Upload beforeUpload={(f) => { user_img_post({ images: f }); return false; }} showUploadList={false}>
                          <Button className="sp-upload-btn" icon={<UploadOutlined />}>Upload Photo</Button>
                        </Upload>
                        <div className="sp-gallery">
                          {image.map((img, idx) => (
                            <div key={idx} className="sp-gal-item">
                              <Image src={`${img.images}`} alt="Gallery" />
                              <button className="sp-gal-del" onClick={() => user_img_delete(img.id)}><FaTrash /></button>
                            </div>
                          ))}
                        </div>
                      </>
                    )}

                    {/* Edit Profile */}
                    {/* Edit Profile */}
                    {activeTab === "edit" && (
                      <>
                        <h2 className="sp-section-title"><EditOutlined /> Edit Profile</h2>
                        <Form onFinish={submit1} form={form} layout="vertical">
                          <Row gutter={[16, 0]}>
                            <Col xs={24} sm={12}><Form.Item label="Full Name" name="firstname"><Input /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Caste" name="caste"><Input readOnly /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Sub Caste" name="subcaste"><Input readOnly /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Gender" name="gender"><Input readOnly /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Religion" name="religion"><Input readOnly /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="DOB" name="dob"><Input type="date" /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Age" name="age"><Input readOnly /></Form.Item></Col>

                            {/* ✅ Marital Status */}
                            <Col xs={24} sm={12}>
                              <Form.Item label="Marital Status" name="marrige_status">
                                <Select
                                  placeholder="Select"
                                  getPopupContainer={(trigger) => trigger.parentNode}
                                >
                                  <Option value="never_married">Unmarried</Option>
                                  <Option value="divorced">Divorced</Option>
                                </Select>
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={12}><Form.Item label="Contact" name="contact" rules={[{ required: true }, { pattern: /^\d{10}$/, message: "10 digits" }]}><Input maxLength={10} /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Email" name="email"><Input readOnly /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Job Title" name="job_title"><Input /></Form.Item></Col>

                            {/* ✅ Job Type */}
                            <Col xs={24} sm={12}>
                              <Form.Item label="Job Type" name="job_type">
                                <Select
                                  placeholder="Select"
                                  getPopupContainer={(trigger) => trigger.parentNode}
                                >
                                  <Option value="Govt">Government</Option>
                                  <Option value="Pvt">Private</Option>
                                </Select>
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={12}><Form.Item label="Salary" name="salary"><Input type="number" /></Form.Item></Col>

                            {/* ✅ Height */}
                            <Col xs={24} sm={12}>
                              <Form.Item label="Height" name="height">
                                <Select
                                  placeholder="Select"
                                  getPopupContainer={(trigger) => trigger.parentNode}
                                  options={[
                                    { value: 140, label: "4'7\" / 140cm" },
                                    { value: 145, label: "4'9\" / 145cm" },
                                    { value: 150, label: "4'11\" / 150cm" },
                                    { value: 155, label: "5'1\" / 155cm" },
                                    { value: 160, label: "5'3\" / 160cm" },
                                    { value: 165, label: "5'5\" / 165cm" },
                                    { value: 170, label: "5'7\" / 170cm" },
                                    { value: 175, label: "5'9\" / 175cm" },
                                    { value: 180, label: "5'11\" / 180cm" },
                                    { value: 185, label: "6'1\" / 185cm" },
                                    { value: 190, label: "6'3\" / 190cm" },
                                  ]}
                                />
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={12}><Form.Item label="Profile URL" name="profile_url"><Input addonAfter={<Button type="link" icon={<CopyOutlined />} onClick={() => copyField("profile_url")} />} /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="LinkedIn" name="linkedin_url"><Input addonAfter={<Button type="link" icon={<CopyOutlined />} onClick={() => copyField("linkedin_url")} />} /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Facebook" name="facebook_url"><Input addonAfter={<Button type="link" icon={<CopyOutlined />} onClick={() => copyField("facebook_url")} />} /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="YouTube" name="youtube_url"><Input addonAfter={<Button type="link" icon={<CopyOutlined />} onClick={() => copyField("youtube_url")} />} /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Instagram" name="instagram_url"><Input addonAfter={<Button type="link" icon={<CopyOutlined />} onClick={() => copyField("instagram_url")} />} /></Form.Item></Col>
                          </Row>
                          <div style={{ textAlign: "center", marginTop: 8 }}><Button htmlType="submit" className="sp-save-btn">Save Changes</Button></div>
                        </Form>
                      </>
                    )}

                    {/* Account / Login */}
                    {activeTab === "login" && (
                      <>
                        <h2 className="sp-section-title"><FaKey /> Account Settings</h2>
                        <Form onFinish={Login_update} form={form} layout="vertical">
                          <Row gutter={[16, 0]}>
                            <Col xs={24} sm={12}><Form.Item label="Username" name="username" rules={[{ required: true }, { min: 4, max: 16 }, { pattern: /^[a-z]+$/, message: "Lowercase only" }]}><Input /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Password" name="password" hasFeedback rules={[{ required: true }]} extra="Min 8 chars"><Input.Password /></Form.Item></Col>
                          </Row>
                          <div style={{ textAlign: "center", marginTop: 8 }}><Button htmlType="submit" className="sp-save-btn">Save Account</Button></div>
                        </Form>
                      </>
                    )}

                    {/* Family */}
                    {activeTab === "family" && (
                      <>
                        <h2 className="sp-section-title"><FaUsers /> Family Details</h2>
                        <Form onFinish={submit} form={form} layout="vertical">
                          <Row gutter={[16, 0]}>
                            <Col xs={24} sm={12}><Form.Item label="Father" name="father_name"><Input /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Mother" name="mother_name"><Input /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Brothers" name="brother"><Input type="number" min="0" /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Married Brothers" name="brother_marrige"><Input type="number" min="0" /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Sisters" name="sister"><Input type="number" min="0" /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Married Sisters" name="sister_marrige"><Input type="number" min="0" /></Form.Item></Col>
                          </Row>
                          <div style={{ textAlign: "center", marginTop: 8 }}><Button htmlType="submit" className="sp-save-btn">Save Family</Button></div>
                        </Form>
                      </>
                    )}

                    {/* Address */}
                    {activeTab === "address" && (
                      <>
                        <h2 className="sp-section-title"><FaMapMarkerAlt /> Location Details</h2>
                        <Form onFinish={submit} form={form} layout="vertical">
                          <Row gutter={[16, 0]}>
                            <Col xs={24} sm={12}><Form.Item label="Country" name="country"><Input /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="State" name="state"><Input /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="District" name="district"><Input /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="City" name="city"><Input /></Form.Item></Col>
                          </Row>
                          <div style={{ textAlign: "center", marginTop: 8 }}><Button htmlType="submit" className="sp-save-btn">Save Location</Button></div>
                        </Form>
                      </>
                    )}

                    {/* Education */}
                    {activeTab === "education" && (
                      <>
                        <h2 className="sp-section-title"><FaGraduationCap /> Education Details</h2>
                        <Form onFinish={submit} form={form} layout="vertical">
                          <Row gutter={[16, 0]}>
                            <Col xs={24} sm={12}><Form.Item label="University" name="university"><Input /></Form.Item></Col>
                            <Col xs={24} sm={12}><Form.Item label="Course" name="course"><Input /></Form.Item></Col>
                          </Row>
                          <div style={{ textAlign: "center", marginTop: 8 }}><Button htmlType="submit" className="sp-save-btn">Save Education</Button></div>
                        </Form>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Spin>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default User_Profile_User;